import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLocation } from 'react-router-dom';
import { trackPageLoad } from '@fff-web/fff-analytics';
import { usePriceLockEligibility } from '@fff-web/fff-utilities';
import Layout from '../../components/Layout';
import * as routePaths from '../../utils/routePaths';
import env from '../MyAccount/utils/env';
import { LockInRateView } from './components';
import { type LockInRateStatus } from './LockInRate.types';

export const LockInRatePage = () => {
  // State
  const { priceLock: priceLockFF, chatbotAppliedLab: showChatbotFF } = useFlags();
  const location = useLocation();
  const { isEligible: isPriceLockEligible, isLoading: isPriceLockEligibilityLoading } =
    usePriceLockEligibility({
      priceLockFF,
    });

  // Constants
  const statusURLParam = new URLSearchParams(location.search).get(
    'status',
  ) as LockInRateStatus | null;

  // Effects
  useEffect(() => {
    trackPageLoad();
  }, []);

  useEffect(() => {
    window.fffPactSafe?.init(process.env.REACT_APP_PACT_SAFE_ID);
  }, [window.fffPactSafe]);

  useEffect(() => {
    if (!priceLockFF || (!isPriceLockEligibilityLoading && !isPriceLockEligible)) {
      window.location.href = `https://${env.hostname}${routePaths.MY_ACCOUNT}`;
    }
  }, [priceLockFF, isPriceLockEligibilityLoading, isPriceLockEligible]);

  return (
    <Layout
      redirectIfNoAuth
      meta={{
        metadata: [
          {
            name: 'description',
            content: 'Lock in your rate',
          },
        ],
      }}
      hideChatWidget={!showChatbotFF}
    >
      <LockInRateView initialLockedRateStatus={statusURLParam} />
    </Layout>
  );
};
